// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-panel {
  display: flex;
  background-color: white;
  margin-bottom: 1rem;
  padding: 1rem 1.5rem;
  border-radius: 1rem;
  box-shadow: 0 0 5px #bbb;
}
.task-panel__main {
  flex: 1;
  margin-left: 1rem;
}
.task-panel__header {
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
}
.task-panel .ant-btn.ant-btn-circle.task-btn {
  margin: 0 3px;
}
.task-panel .ant-btn.ant-btn-circle.task-btn.ant-btn-icon-only:active,
.task-panel .ant-btn.ant-btn-circle.task-btn.ant-btn-icon-only:focus {
  color: #333;
}
.task-panel .task-btn.ant-tooltip-disabled-compatible-wrapper {
  margin-left: 5px;
}
.task-btn .ant-btn[disabled] {
  background: none;
}
.task-name {
  flex: 1;
  font-weight: 600;
  word-break: break-word;
}
.parts-list {
  padding: 0 1.5rem 1rem 1.5rem;
}
.parts-list__item {
  display: block;
  margin-bottom: 0.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/TasksList/TaskPanel/style.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,wBAAA;AACF;AACE;EACE,OAAA;EACA,iBAAA;AACJ;AAEE;EACE,aAAA;EACA,8BAAA;EAEA,kBAAA;AADJ;AAhBA;EAoBI,aAAA;AADJ;AAEI;;EACE,WAAA;AACN;AAvBA;EA0BI,gBAAA;AAAJ;AAIA;EACE,gBAAA;AAFF;AAKA;EACE,OAAA;EACA,gBAAA;EACA,sBAAA;AAHF;AAMA;EACE,6BAAA;AAJF;AAME;EACE,cAAA;EACA,sBAAA;AAJJ","sourcesContent":[".task-panel {\n  display: flex;\n  background-color: white;\n  margin-bottom: 1rem;\n  padding: 1rem 1.5rem;\n  border-radius: 1rem;\n  box-shadow: 0 0 5px #bbb;\n\n  &__main {\n    flex: 1;\n    margin-left: 1rem;\n  }\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n\n    margin-top: 0.5rem;\n  }\n  .ant-btn.ant-btn-circle.task-btn {\n    margin: 0 3px;\n    &.ant-btn-icon-only:active, &.ant-btn-icon-only:focus {\n      color: #333;\n    }\n  }\n  .task-btn.ant-tooltip-disabled-compatible-wrapper {\n    margin-left: 5px;\n  }\n}\n\n.task-btn .ant-btn[disabled] {\n  background: none;\n}\n\n.task-name {\n  flex: 1;\n  font-weight: 600;\n  word-break: break-word;\n}\n\n.parts-list {\n  padding: 0 1.5rem 1rem 1.5rem;\n\n  &__item {\n    display: block;\n    margin-bottom: 0.25rem;\n  }\n}\n\n@display-sm: ~\"only screen and (min-width:576px) \";@display-md: ~\"only screen and (min-width:768px)\";@display-lg: ~\"only screen and (min-width:992px)\";@display-xl: ~\"only screen and (min-width:1200px)\";@display-xxl: ~\"only screen and (min-width:1680px)\";@font-family: 'Open Sans', sans-serif;@font-size-base: 15px;@font-size-lg: @font-size-base + 2px;@font-size-sm: @font-size-base - 2px;@white: #fff;@beey-orange: #f3ab58;@beey-orange-darken: #f29f40;@beey-yellow-light: #fef9e9;@beey-blue: #698efc;@beey-blue-light: #82a1fc;@primary-color: @beey-orange-darken;@link-color: @beey-orange-darken;@text-color: #444;@text-color-secondary: #888;@heading-color: #303030;@header-height: 5rem;@header-height-sm: 3rem;@header-line-height: 2rem;@playback-height: 65px;@color-error: #95190c;@text-primary-disabled: #999;@text-secondary: #000000;@text-secondary-dimmed: #666;@text-heading1: #000000;@font-weight-semi-bold: 600;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
